import ChildStatusTransition from '../dto/ChildStatusTransition';
import Error from '../model/Error';
import axios from 'axios';

export default class ChildStatusTransitionRepository {
    static findForChild(childId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/children/${childId}/status-transitions`)
                .then((response) => resolve(response.data.data.map((data) => ChildStatusTransition.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(id, date) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/child-status-transitions/${id}`, { date: date.format('YYYY-MM-DD') })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/child-status-transitions/${id}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(childId, dto, date) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/children/${childId}/status-transitions`, {
                    target_status: dto.targetStatus,
                    date: date.format('YYYY-MM-DD'),
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
